import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'first-employment',
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        RadioButtonModule,
        CheckboxModule,
        TooltipModule,
    ],
    templateUrl: './first-employment.component.html',
    styleUrls: ['./first-employment.component.scss'],
    standalone: true,
})
export class FirstEmploymentComponent implements OnInit {
    @Input() form: FormGroup;

    translate = inject(TranslateService);

    constructor() { }

    ngOnInit(): void { }
}
